import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { anamnesisFrag } from './types/anamnesis.types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { AnamnesisUpdateInput } from '@libs/types/src/services/input-type/anamnesis/anamnesis.update-input';
import { AnamnesisCreateInput } from '@libs/types/src/services/input-type/anamnesis/anamnesis.create-input';
import { exportFrag } from './types/common.types';
import { FolderPrintObject } from '@libs/types/src/services/object-type/folder/folder-print-object';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { AnamnesisGridObject, AnamnesisObject } from '@libs/types/src/services/object-type/anamnesis/anamnesis.object';
import { OkObject } from '@it2go/types';
import { BaseFolderExportInput } from '@libs/types/src/services/input-type/folder/base-folder.export-input';

@Injectable({ providedIn: 'root'})
export class AnamnesisGqlServiceV2 extends GqlServiceV2 {

    public getAnamneses(input: GridInput, frag: string = anamnesisFrag) {
        return this.query<AnamnesisGridObject>(
            `
                query($input: GridInput) {
                    anamnesis {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createAnamnesis(input: AnamnesisCreateInput, frag: string = 'ok') {
        return this.mutate<AnamnesisObject>(
            `
                mutation($input: AnamnesisCreateInput!) {
                    anamnesis {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateAnamnesis(input: AnamnesisUpdateInput, frag: string = 'ok') {
        return this.mutate<AnamnesisObject>(
            `
                mutation($input: AnamnesisUpdateInput!) {
                    anamnesis {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteAnamnesis(input: IdInput, frag: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    anamnesis {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public exportAnamnesis(input: BaseFolderExportInput, frag: string = exportFrag) {
        return this.query<FolderPrintObject>(
            `
                query($input: BaseFolderExportInput!) {
                    anamnesis {
                        export(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
